import { useEffect, useRef, useState } from "react";
import { TestType } from "./Components/TestType/TestType";
import "./MockTest.scss";
import { TestDurationIndex } from "./TestDuration";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AppRouteURL, TestRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { toast } from "react-hot-toast";
import { TestTypes } from '@Constants/app.constant';
import { log } from "node:console";
import SvgIcon from "@Components/icons/SvgIcon";
import { useAppSelector } from "@Src/app/hooks";

export const MockTestIndex = () => {
    const params = useParams();
    const navigation = useNavigate();
    const location = useLocation();
    const [selectionOptionScreen, setSelectionOptionScreen] = useState(1);
    const selectionScreenHandler = (option: number) => {
        setSelectionOptionScreen(option)
    }
    const testId = params.testId;
    const examId = params.examId;
    const [testtype, setTesttype] = useState(-1);
    const [testDuration, setTestDuration] = useState(-1);
    const [isTestSeries, setIsTestSeries] = useState<boolean>(false);
    const isDiagnosticTestSeries = location.pathname.includes(`${AppRouteURL.DIAGNOSTIC_MOCKTEST_SERIES}`);
    const isFullMockTestSeries = location.pathname.includes(`${AppRouteURL.FULL_MOCK_TEST_SERIES}`);
    const isPreviousYearMockTestSeries = location.pathname.includes(`${AppRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES}`);

    const coursePreferencesSnapshotRef = useRef<string | null>(null);

    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const navigate = useNavigate();



    useEffect(() => {
        // if (location.key === "default") {
        //     navigation(AppRouteURL.NOT_FOUND);
        // }
        if (location.pathname.includes(`${AppRouteURL.MOCKTEST_SERIES}`) || location.pathname.includes(`${AppRouteURL.DIAGNOSTIC_MOCKTEST_SERIES}`) || location.pathname.includes(`${AppRouteURL.FULL_MOCK_TEST_SERIES}`) || location.pathname.includes(`${AppRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES}`)) {
            setIsTestSeries(true);
        } else {
            setIsTestSeries(false);
        }
    }, [location])

    const onContinueClick = (type?: number, duration?: number) => {
        const currentType = type !== undefined ? type : testtype;
        const currentDuration = duration !== undefined ? duration : testDuration;

        if (currentType == TestTypes.regular) {
            if (isTestSeries) {
                if (isFullMockTestSeries) {
                    navigation(`${TestSereisRouteURL.FULL_MOCK_TEST_SERIES}/${examId}`, { state: { flagTest: examId } })
                } else if (isPreviousYearMockTestSeries) {
                    navigation(`${TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES}/${examId}`, { state: { flagTest: examId } })
                } else {
                    navigation(`${TestRouteURL.TEST_SERIES}/${examId}`, { state: { flagTest: examId } })
                }
            } else {
                navigation(`${TestRouteURL.TEST}/${testId}`, { state: { flagTest: testId } })
            }
        } else if (currentType == TestTypes.speed) {
            if (currentDuration >= 0) {
                if (isTestSeries) {

                    if (isDiagnosticTestSeries) {
                        // navigation(`${TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES}/${examId}?duration=${currentDuration}`)
                        navigation(`${TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES}/${examId}`, { state: { duration: currentDuration, flagTest: examId } })
                    } else if (isFullMockTestSeries) {

                        navigation(`${TestSereisRouteURL.FULL_MOCK_SPEED_TEST_SERIES}/${examId}`, { state: { duration: currentDuration, flagTest: examId } })
                    } else if (isPreviousYearMockTestSeries) {
                        navigation(`${TestSereisRouteURL.PREVIOUS_YEAR_MOCK_SPEED_TEST_SERIES}/${examId}`, { state: { duration: currentDuration, flagTest: examId } })
                    } else {
                        // navigation(`${TestRouteURL.SPEED_TEST_SERIES}/${examId}?duration=${currentDuration}`)
                        navigation(`${TestRouteURL.SPEED_TEST_SERIES}/${examId}`, { state: { duration: currentDuration, flagTest: examId } })
                    }
                } else {
                    // navigation(`${TestRouteURL.SPEED_TEST}/${testId}?duration=${currentDuration}`)
                    navigation(`${TestRouteURL.SPEED_TEST}/${testId}`, { state: { duration: currentDuration, flagTest: testId } })
                }
            } else {
                toast.error('Please select test duration')
            }
        } else {
            toast.error("Please select test type")
        }
    }

    const testTypeHandler = (option: number) => {
        setTesttype(option);
    }

    const durationHandler = (option: number) => {
        setTestDuration(option);
    }

    const onBackClick = () => {
        setSelectionOptionScreen(1);
    }


    const coursePreferencesKey = JSON.stringify({
        boardDetails: coursePreferences?.boardDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
        classDetails: coursePreferences?.classDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
        educationInterestDetails: coursePreferences?.educationInterestDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
        subjectDetails: coursePreferences?.subjectDetails?.map(({ Id, Name }: any) => ({ Id, Name })) || [],
    });

    useEffect(() => {
        if (coursePreferencesSnapshotRef.current === null) {
            coursePreferencesSnapshotRef.current = coursePreferencesKey;
            return;
        }

        if (coursePreferencesSnapshotRef.current !== coursePreferencesKey) {
            coursePreferencesSnapshotRef.current = coursePreferencesKey;

            if (location.pathname.startsWith('/dashboard/mocktestseries')) {
                navigate('/testseries',{replace:true})
            }else if(location.pathname.startsWith('/dashboard/diagnostic-testseries')){
                navigate('/diagnostic-testseries', {replace:true})
            }else if(location.pathname.startsWith('/dashboard/previous-year-testseries')){
                navigate('/previous-year-testseries', {replace:true})
            }else if(location.pathname.startsWith('/dashboard/full-mock-testseries')){
                navigate('/full-mock-testseries', {replace:true})
            }

        }
    }, [coursePreferencesKey]);

    return (
        <>
            <div className="test-type-selection-container" style={{ padding: "20px 20px" }}>
                <div className="test-selection-header" style={{ marginBottom: "10px" }}>
                    <div className="test-typ-header">{isDiagnosticTestSeries ? "Readiness Check" : (isFullMockTestSeries ? "Mock Test" : (isPreviousYearMockTestSeries ? "Previous Year Test" : "Practice Test"))}</div>

                    {
                        (!isDiagnosticTestSeries && !isFullMockTestSeries && !isPreviousYearMockTestSeries) ? <div className="test-typ-subtitle">Select how you want to practice based on your current goal</div> : <div className="test-typ-subtitle">Get Ready to start your selected test </div>
                    }

                </div>

                {/* <div className="top-tip-box">
                    <SvgIcon name="bulb" className="tip-icon" size={20} />
                    <span>New to practice? Start with <strong>Regular Practice</strong> to build concepts, then move to <strong>Speed Tests</strong>.</span>
                </div> */}

                <TestType
                    testTypeHandler={testTypeHandler}
                    durationHandler={durationHandler}
                    isDiagnosticTestSeries={isDiagnosticTestSeries}
                    isFullMockTestSeries={isFullMockTestSeries}
                    isPreviousYearMockTestSeries={isPreviousYearMockTestSeries}
                    onContinueClick={onContinueClick}
                />

                {/* <div className="bottom-helper-section">
                    <div className="helper-box">
                        <div className="helper-icon-wrapper">
                            <SvgIcon name="question" size={24} />
                        </div>
                        <div className="helper-content">
                            <div className="helper-title">Not sure which one to choose?</div>
                            <div className="helper-desc">Regular Practice helps you build a strong base. Speed Practice helps you perform better in the real exam.</div>
                        </div>
                    </div>

                    <div className="helper-box">
                        <div className="helper-icon-wrapper">
                            <SvgIcon name="crown" size={24} />
                        </div>
                        <div className="helper-content">
                            <div className="helper-title">Pro Tip</div>
                            <div className="helper-desc">Combine both modes in your preparation for maximum improvement.</div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
};
